import { Formik } from "formik";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import FormDisplay from "./FormDisplay";
import pages from "../../../constants/pages";
import { useAxios, useComponent } from "../../../hooks";
import { objectFromFormData, validationSchema } from "./onboardingObjects";
import { useState } from "react";

export default function Form({
  fieldValue,
  fields,
  brands,
  formData,
  editState,
  setEditState,
  additionalFields,
  PlatformTenantList,
}) {
  const axios = useAxios();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { alert } = useComponent();
  const [changeData, setChangeData] = useState(false);

  return (
    <Formik
      enableReinitialize
      initialValues={formData}
      validateOnChange
      validationSchema={validationSchema}
      onSubmit={(formData, { setSubmitting }) => {
        let url = "/user/onboarding";
        if (formData.onboardingType === "API") {
          url = "/user/onboarding/api-based";
        }
        axios({
          url: url,
          method: "POST",
          data: objectFromFormData(formData, fieldValue),
          disableRedirect: true,
        }).then((response) => {
          if (response.status) {
            navigate(
              pages.dpOnBoardingDetails.route +
                response.data.id +
                "?brandID=" +
                response?.data?.brand_id
            );
            setEditState(false);
            setChangeData(false);
            dispatch(alert.success(response?.message?.displayMessage));
          }

          setSubmitting(false);
        });
      }}
    >
      {(formikProps) => (
        <FormDisplay
          PlatformTenantList={PlatformTenantList}
          additionalFields={additionalFields}
          fields={fields}
          formikProps={formikProps}
          brands={brands}
          editState={editState}
          setEditState={setEditState}
          changeData={changeData}
          setChangeData={setChangeData}
        />
      )}
    </Formik>
  );
}
